import "../../../assets/RideTag.css";
import _ from "clsx";
import i from "react";
const o = "_success_14tz7_12", l = "_strong_14tz7_12", u = "_subtle_14tz7_16", g = "_warning_14tz7_20", m = "_critical_14tz7_28", z = "_informative_14tz7_36", d = "_neutral_14tz7_44", t = {
  "ride-tag": "_ride-tag_14tz7_1",
  success: o,
  strong: l,
  subtle: u,
  warning: g,
  critical: m,
  informative: z,
  neutral: d,
  null: "_null_14tz7_48"
};
function v({
  case: s = "neutral",
  className: e,
  type: n = "subtle",
  text: a = "Tag status",
  "data-testid": r
}) {
  const c = () => _(e, t["ride-tag"], t[s], t[n]);
  return /* @__PURE__ */ i.createElement("p", { "data-testid": r, className: c() }, a);
}
export {
  v as RideTag
};
